<script>
import Translatable from '@src/mixins/translatable.js'

export default {
  mixins: [Translatable],
  props: {
    showModal: Boolean,
    text: {
      type: String,
      default: 'Thank you for your feedback!',
    },
    isButton: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick() {
      this.$emit('toggle', 'showFeedback')
    },
    onBtnClick() {
      this.$emit('emitFunc')
    },
  },
}
</script>

<template>
  <div class="app">
    <div class="modal-background" @click="onClick"></div>
    <div class="modal">
      <div class="cross" @click="onClick"></div>
      <div class="text" v-html="text"> </div>
      <div v-if="isButton" class="buttons-container">
        <div class="link">
          <button class="button-cancel" @click="onBtnClick">{{ 'Ok' }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.app {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 1098;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 20px;
}

.modal-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  cursor: pointer;
}

.modal {
  position: relative;
  background-color: $white;
  width: 100%;
  max-width: 650px;
  max-height: 90vh;
  min-height: 150px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  z-index: 1100;
  padding: 40px 30px 30px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

::v-deep .text {
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  line-height: 1.5;
  color: $black;
  overflow-y: auto;
  padding-right: 8px;

  & p {
    line-height: 1.2;
    // margin-bottom: 10px;
  }
  & p:empty {
    height: 1.2em;
    margin: 0;
  }

  & p > br {
    display: none;
  }

  & p:has(br:last-child)::after {
    content: '';
    display: block;
    height: 18px;
  }

  & em {
    font-style: italic;
  }

  & a {
    color: $gray;
    text-decoration: none;

    &:hover {
      color: $orange;
    }
  }

  & ul {
    margin-left: 20px;
    list-style: initial;
  }

  & strong {
    font-family: Open Sans Bold, sans-serif;
    font-style: normal;
    font-weight: bold;
  }

  img {
    max-width: 100%;
    height: auto;

    display: inline-block;
    vertical-align: middle;
  }

  div[style*='text-align:center'] {
    text-align: center !important;
  }
  div {
    &[style*='text-align:none'],
    &:not([style]) {
      text-align: center;
    }
  }
  // editor support (Quill)
  .ql-align-center {
    text-align: center;
  }
  .ql-align-right {
    text-align: right;
  }
  .ql-align-left {
    text-align: left;
  }
}

.cross {
  cursor: pointer;
  position: absolute;
  width: 32px;
  height: 32px;
  top: 12px;
  right: 12px;
  z-index: 1110;
  background: url('../../assets/icons/cross-small.svg') center no-repeat;
  background-size: 20px;
  opacity: 0.6;
  transition: opacity 0.2s;

  &:hover {
    opacity: 1;
  }
}

.buttons-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  flex-shrink: 0;
}

.button-cancel {
  min-width: 180px;
  height: 48px;
  border: 1px solid $gray;
  border-radius: 8px;
  background: $white;
  color: $black;
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: $gray;
    color: $white;
    border-color: $gray;
  }
}

@media only screen and (max-width: $container-width-xs) {
  .modal {
    padding: 35px 20px 20px;
    max-width: 100%;
  }

  ::v-deep .text {
    font-size: 14px;

    span[style*='font-size: 48px'] {
      font-size: 28px !important;
    }

    span[style*='font-size: 36px'] {
      font-size: 24px !important;
    }

    span[style*='font-size: 30px'] {
      font-size: 20px !important;
    }

    & p {
      line-height: 1.3 !important;
    }
  }

  .button-cancel {
    min-width: 100%;
  }
}
</style>
